module.exports = __webpack_public_path__ + "static/media/insta.eef3d123.svg";